import React from 'react';
import { Form } from 'semantic-ui-react';
import PropTypes from 'prop-types';

import { MappingModal } from 'Components/dialogs/MappingModal';

export class MappingModalField extends React.Component {
  static propTypes = {
    mappingOptions: PropTypes.array.isRequired,
    input: PropTypes.shape({
      onChange: PropTypes.func.isRequired,
      value: PropTypes.oneOfType([PropTypes.object]),
    }).isRequired,
    doneCallback: PropTypes.func,
    showDialog: PropTypes.bool,
    title: PropTypes.string,
  };

  static defaultProps = {
    showDialog: true,
    doneCallback: () => {},
  };

  saveCallback = data => {
    const {
      doneCallback,
      input: { onChange },
    } = this.props;

    let dataObject = {};
    data.forEach(i => {
      dataObject[i.key] = i.value;
    });
    onChange(dataObject);
    doneCallback();
  };

  getFormattedData = () => {
    const mappedValues = this.props.input.value;

    return Object.keys(mappedValues).map(key => ({
      key: key,
      value: mappedValues[key],
    }));
  };

  render() {
    const { doneCallback, ...rest } = this.props;
    return (
      <Form.Field>
        <MappingModal
          saveCallback={this.saveCallback}
          closeCallback={doneCallback}
          data={this.getFormattedData()}
          {...rest}
        />
      </Form.Field>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/ReduxFormFields/MappingModalField.js